<script>
import Chart from 'chart.js'
import getColor from '@utils/colors.js'
import isMobileDevice from '@utils/helpers/is-mobile'
import chartConfig from './chart-config'
import axios from 'axios'

export default {
  name: 'OilTotalConsumptionChart',
  props: {
    workshopId: {
      type: [Number, String],
      required: true,
    },
  },
  data: () => ({
    oilData: null,
    isLoading: true,
    showOuterLegend: false,
    parsedChartData: null,
    chart: null,
    chartLegendVisibility: {
      legend: {
        position: 'bottom',
        display: true,
      },
    },
  }),
  computed: {
    unitsMeasurement() {
      return this.$store.getters['userSettings/getUnitsMeasurement']
    },
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
  },
  async mounted() {
    if (this.isMobileDevice()) {
      this.setLegendDefaultVisibility(false)
    }
    await this.fetchData()
    this.parsedChartData = this.updateChartData(this.oilData)
    this.chart = this.buildChart(this.parsedChartData)
    this.isLoading = false
  },
  methods: {
    isMobileDevice,
    fetchData() {
      return axios
        .get(`/api/1/report/oil_total_consumption/${this.workshopId}`)
        .then(response => {
          this.oilData = [...response.data]
        })
    },
    buildChart(chartData) {
      let ctx = this.$refs.totalConsumptionChart.getContext('2d')
      Chart.defaults.global.elements.point.radius = 0
      const mergedChartData = {
        ...chartConfig,
        data: { ...chartData },
        options: {
          ...chartConfig.options,
          legend: this.chartLegendVisibility.legend,
        },
      }

      return new Chart(ctx, mergedChartData)
    },
    updateChartData(oilData) {
      let chartStructuredData = {
        labels: [],
        datasets: [
          {
            labels: 'test',
            data: [],
            backgroundColor: [],
          },
        ],
      }
      oilData.map((oilItem, index) => {
        chartStructuredData.datasets[0].data.push(
          (+oilItem.volume / this.unitsMeasurement.volumeMultiplier).toFixed(2)
        )
        chartStructuredData.datasets[0].backgroundColor.push(
          getColor(oilItem.oil)
        )
        chartStructuredData.labels.push(this.getValue('goods', oilItem.oil))
      })
      return chartStructuredData
    },
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value ? Number(value) : value
      )
    },
    getBackgroundColor(index) {
      return this.parsedChartData.datasets[0].backgroundColor[index]
    },
    toggleOuterLegend() {
      this.showOuterLegend = !this.showOuterLegend
      this.chart.options.legend.display = this.showOuterLegend
      this.chart.update()
      this.$forceUpdate()
    },
    setLegendDefaultVisibility(newValue) {
      this.chartLegendVisibility.legend.display = newValue
    },
  },
}
</script>

<template>
  <div>
    <v-flex class="pl-4 pb-4">
      <p class="subheading">{{ $t('reports__OilTotalConsumption') }}</p>
    </v-flex>
    <canvas
      v-if="oilData && oilData.length > 0"
      v-show="!isLoading"
      id="totalConsumptionChart"
      ref="totalConsumptionChart" />
    <div
      v-else
      style="text-align: center">{{ $t('label__no_data_available') }}</div>
    <div
      v-if="isMobileDevice()"
      style="display: grid; padding-bottom: 60px">
      <v-btn
        @click="toggleOuterLegend()">
        {{ $t('label__legend') }} <v-icon v-if="!showOuterLegend">visibility</v-icon><v-icon v-else>visibility_off</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}

.rectangle {
  width: 40px;
  height: 15px;
  margin-right: 6px;
  margin-left: 12px;
}

.legendContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.legend {
  display: contents;
  font-size: 12px;
}
</style>
